

















































import Vue from 'vue';
import Component from 'vue-class-component';
import { getOr } from '@/utilities/helpers';

const Setup = Vue.extend({
	name: 'FormInput',
	props: {
		description: String,
		error: String,
		errorMessages: { type: Object, default() { return {}; } },
		hideLabel: Boolean,
		inputId: String,
		label: String,
		labelClass: String,
		required: Boolean,
		vuelidate: { type: Object, default() { return {}; } },
	},
});

@Component
export default class FormInput extends Setup {
	// Props
	public description!: string;
	public error!: string;
	public errorMessages!: { [error: string]: string };
	public hideLabel!: boolean;
	public inputId!: string;
	public label!: string;
	public labelClass!: string;
	public required!: boolean;
	public name!: string;
	public vuelidate!: any;

	public get errorKeys(): string[] {
		return Object.keys(this.errorMessages);
	}

	public get hasError(): boolean {
		return (this.vuelidate.$error && this.vuelidate.$dirty) || !!this.error;
	}

	public get vuelidateError(): string | undefined {
		return this.vuelidateErrors[0];
	}

	public get vuelidateErrors(): string[] {
		if (!this.vuelidate.$error || !this.vuelidate.$dirty) {
			return [];
		}

		return this.errorKeys
			.filter((key: string) => !this.vuelidate[key])
			.map((key: string) => this.errorMessages[key] || '');
	}

	public emitValue(value: any) {
		if (value instanceof Event) {
			this.$emit('input', getOr(value, 'target.value', value));
		} else {
			this.$emit('input', value);
		}
	}

	public get classComputed(): string {
		return `np-label${this.required ? ' np-label--required' : ''}${this.hideLabel ? ' np-hide' : ''}${this.labelClass ? ` ${this.labelClass}` : ''}`;
	}
}
